
import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

type Props = {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
};

const COLORS = {
  border: "#E3E7ED",
  borderHover: "#C7CDD3",
  bg: "#FFFFFF",
  bgHover: "#F8FAFC",
  icon: "#9AA0A6",
  iconDisabled: "#B7BDC4",
};

const circleBtnSx = {
  width: 36,
  height: 36,
  borderRadius: "50%",
  border: `2px solid ${COLORS.border}`,
  backgroundColor: COLORS.bg,
  transition: "background-color 120ms ease, border-color 120ms ease",
  "& .MuiSvgIcon-root": { fontSize: 20, color: COLORS.icon },
  "&:hover": {
    backgroundColor: COLORS.bgHover,
    borderColor: COLORS.borderHover,
  },
  "&.Mui-disabled": {
    opacity: 0.45,
    borderColor: COLORS.border,
    "& .MuiSvgIcon-root": { color: COLORS.iconDisabled },
  },
} as const;

export default function CustomPaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}: Props) {
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

  const handleBack = (e: React.MouseEvent<HTMLButtonElement>) => onPageChange(e, page - 1);
  const handleNext = (e: React.MouseEvent<HTMLButtonElement>) => onPageChange(e, page + 1);

  return (
    <>
      <Tooltip title="Previous page">
        <span>
          <IconButton
            onClick={handleBack}
            disabled={page <= 0}
            size="small"
            sx={circleBtnSx}
            aria-label="previous page"
          >
            <ChevronLeftIcon />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Next page">
        <span>
          <IconButton
            onClick={handleNext}
            disabled={page >= lastPage}
            size="small"
            sx={{ ml: 1, ...circleBtnSx }}
            aria-label="next page"
          >
            <ChevronRightIcon />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
}
